import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    CancelScreeningRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/basicapplicantscreening/:applicationId/cancel`
    },
    GetScreeningReport: {
        method: 'GET',
        url: `${BASE_PATH_API}/basicapplicantscreening/:screeningRequestId/reports/:reportType`
    },
    ResendScreeningRequest: {
        url: `${BASE_PATH_API}/basicapplicantscreening/:screeningRequestId/resend`,
        method: 'POST'
    },
    SaveCriminalReportRequest: {
        url: `${BASE_PATH_API}/basicapplicantscreening/:screeningRequestId/requestCriminal`,
        method: 'POST'
    },
    GetLandlordPrefill: {
        url: `${BASE_PATH_API}/basicapplicantscreening/landlord/prefill`,
        method: 'GET'
    },
    CancelSingleScreeningRequest: {
        method: 'POST',
        url: `${BASE_PATH_API}/basicapplicantscreening/:id/cancelScreening`
    },
    ResendScreeningRequestEmail: {
        method: 'POST',
        url: `${BASE_PATH_API}/basicapplicantscreening/:screeningRequestId/resendEmail/:applicantId`
    }
};

export function BasicApplicantScreeningApi() {
    return createActions(actions);
}
